var _g, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 19,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 16,
    fill: "#F2E735"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3 24.43C31.048 24.3515 30.7752 24.3757 30.5411 24.4975C30.3069 24.6192 30.1304 24.8286 30.05 25.08C29.5776 26.5245 28.6566 27.7805 27.421 28.6654C26.1854 29.5503 24.6997 30.0178 23.18 30C21.3003 30.0214 19.4889 29.2965 18.143 27.9842C16.797 26.672 16.0264 24.8796 16 23C16.0264 21.1204 16.797 19.328 18.143 18.0158C19.4889 16.7035 21.3003 15.9786 23.18 16C24.8776 15.9959 26.5229 16.5868 27.83 17.67L25.66 17.31C25.5299 17.2886 25.3969 17.2931 25.2686 17.3233C25.1403 17.3535 25.0193 17.4087 24.9124 17.4859C24.8055 17.563 24.715 17.6605 24.6459 17.7728C24.5768 17.885 24.5307 18.0098 24.51 18.14C24.4886 18.27 24.4931 18.403 24.5233 18.5313C24.5535 18.6596 24.6087 18.7807 24.6859 18.8876C24.763 18.9945 24.8605 19.085 24.9728 19.1541C25.085 19.2232 25.2098 19.2693 25.34 19.29L29.58 19.99H29.75C29.866 19.9899 29.981 19.9696 30.09 19.93C30.1266 19.9161 30.1605 19.8958 30.19 19.87C30.2617 19.8433 30.3291 19.8063 30.39 19.76L30.48 19.65C30.48 19.6 30.57 19.56 30.61 19.5C30.65 19.44 30.61 19.4 30.66 19.36C30.6876 19.3018 30.711 19.2416 30.73 19.18L31.48 15.18C31.505 15.0487 31.5038 14.9137 31.4766 14.7829C31.4494 14.652 31.3967 14.5277 31.3215 14.4172C31.2462 14.3067 31.15 14.2121 31.0382 14.1388C30.9264 14.0655 30.8013 14.0149 30.67 13.99C30.5387 13.965 30.4037 13.9662 30.2729 13.9934C30.142 14.0206 30.0177 14.0733 29.9072 14.1485C29.6841 14.3004 29.5304 14.5348 29.48 14.8L29.21 16.25C27.536 14.7992 25.3952 14.0004 23.18 14C20.7699 13.9787 18.4498 14.9143 16.7288 16.6016C15.0078 18.2889 14.0264 20.59 14 23C14.0264 25.41 15.0078 27.7111 16.7288 29.3984C18.4498 31.0857 20.7699 32.0213 23.18 32C25.1331 32.03 27.0443 31.4321 28.6321 30.2944C30.22 29.1566 31.4005 27.5391 32 25.68C32.0379 25.552 32.0498 25.4176 32.035 25.2849C32.0202 25.1522 31.9789 25.0238 31.9137 24.9073C31.8485 24.7908 31.7605 24.6886 31.6551 24.6066C31.5497 24.5246 31.429 24.4646 31.3 24.43Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.ae41ea51.svg";
export { ForwardRef as ReactComponent };